<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousAir"
            >&laquo; Back</md-button>
          </md-layout>

          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>Execution Sea Import(Conso)</h2>
          </md-layout>
        </md-layout>
        <hr class="hr-s">

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Assignment No.</label>
              <b-form-input :formatter="capitalizeAll"
                name="conSeaImportSeries"
                id="conSeaImportSeries"
                v-model="mainPageModal.conSeaImportSeries"
                disabled
              ></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label for="bookingShipment">Booking Transhipment</label>
            <model-list-select
              option-value="bookingShipmentVal"
              option-text="bookingShipmentText"
              :list="bookingShipmentList"
              placeholder="Select Booking Transhipment"
              v-model="BookingShippingLine.bookingShipment"
              :isDisabled="tentativeDetailArray.length == 0?false:true"
            ></model-list-select>

            <span
              class="error"
              v-if="!BookingShippingLine.bookingShipment"
            >{{errorBookingShippingLine.bookingShipment}}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30" style="margin-top:1%">
            <h4
              style="margin-top:-11px"
              class="showMoreData"
              v-if="BookingShippingLine.bookingShipment=='yes'"
              @click="showAddAirportmet"
            >Click here to {{showAddAirport==false?"Add ":"Hide"}} Transhipment</h4>
          </md-layout>
        </md-layout>

        <div
          v-if="BookingShippingLine.bookingShipment=='yes' && showAddAirport==true"
          id="TranshipmentDetail"
        >
          <hr class="hr-border">
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="25"></md-layout>
            <md-layout md-flex="30">
              <label for="fromPort">From Port</label>
              <model-list-select
                @input="getLocationList($event,'Sea_Port','portListFP')"
                @searchchange="getLocationList($event,'Sea_Port','portListFP')"
                option-value="pickupId"
                option-text="pickupLocation"
                :list="portListFP"
                placeholder="Select Port Name"
                v-model="moreAirportModel.fromPort"
              ></model-list-select>
              <span class="error" v-if="!moreAirportModel.fromPort">{{errorAirport.fromPort}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label>ETD(From Port)</label>
              <date-picker
              :format="selectDateFormat"
                lang="en"
                id="etdFromPort1"
                name="etdFromPort1"
                v-model="moreAirportModel.etdFromPort"
              ></date-picker>
            </md-layout>
          </md-layout>

          <md-layout gutter class="labelMargtop">
            <md-layout md-flex="25"></md-layout>
            <md-layout md-flex="30">
              <label for="toPort">To Port</label>
              <model-list-select
                @input="getLocationList($event,'Sea_Port','portListTP')"
                @searchchange="getLocationList($event,'Sea_Port','portListTP')"
                option-value="pickupId"
                option-text="pickupLocation"
                :list="portListTP"
                placeholder="Select Port Name"
                v-model="moreAirportModel.toPort"
              ></model-list-select>
              <span class="error" v-if="!moreAirportModel.toPort">{{errorAirport.toPort}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <label>ETA(To Port)</label>
              <date-picker
              :format="selectDateFormat"
                lang="en"
                id="etaToPort1"
                name="etaToPort1"
                v-model="moreAirportModel.etaToPort"
              ></date-picker>
              <span class="error" v-if="!moreAirportModel.etaToPort">{{errorAirport.etaToPort}}</span>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="25"></md-layout>
            <md-layout md-flex="30">
              <label>Vessel Name and Voyage</label>
              <b-form-textarea :formatter="capitalizeAll"
                name="flightNo1"
                id="flightNo1"
                v-model="moreAirportModel.vesselVoyage"
              ></b-form-textarea>

              <span
                class="error"
                v-if="!moreAirportModel.vesselVoyage"
              >{{errorAirport.vesselVoyage}}</span>
            </md-layout>
            <md-layout md-flex="15"></md-layout>
            <md-layout md-flex="20">
              <md-button
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                @click="addTransExec('')"
                id="addButtonLoader1"
                style="margin-top:7%"
              >{{moreAirportModel.multiTransSeaExexId==""?"Add":"edit"}} Port</md-button>
            </md-layout>
          </md-layout>
          <hr class="hr-border" v-if="tentativeDetailArrayList.length>0">
        </div>
        <div class="box" v-if="tentativeDetailArrayList.length>0">
          <div class="box-header">
            <h3 class="box-title">Transhipment Details</h3>
          </div>

          <!-- /.box-header -->
          <div class="box-body">
            <table id="ffBookingTentative" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>From Port</th>
                  <th>To Port</th>
                  <th>ETD (From Port)</th>
                  <th>ETA (To Port)</th>
                  <!-- <th>Item Number</th> -->
                  <th>Edit</th>
                  <!--  <th>Delete</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in tentativeDetailArrayList" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.fromportName }}</td>
                  <td>{{item.toportName }}</td>
                  <td>{{item.etdFromPort | moment}}</td>
                  <td>{{item.etaToPort | moment}}</td>

                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="viewEdit(item,index)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
        <hr class="hr-border" v-if="tentativeDetailArrayList.length>0 || showAddAirport==true">

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label for="fromPort">From Port</label>
            <model-list-select
              @input="getLocationList($event,'Sea_Port','portListFPT')"
              @searchchange="getLocationList($event,'Sea_Port','portListFPT')"
              option-value="pickupId"
              option-text="pickupLocation"
              :list="portListFPT"
              placeholder="Select Port Name"
              v-model="BookingShippingLine.fromPort"
            ></model-list-select>

            <span
              class="error"
              v-if="!BookingShippingLine.fromPort"
            >{{errorBookingShippingLine.fromPort}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <label>ETD(From Port)</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="etdFromPort"
              name="etdFromPort"
              v-model="BookingShippingLine.etdFromPort"
            ></date-picker>
            <span
              class="error"
              v-if="!BookingShippingLine.etdFromPort"
            >{{errorBookingShippingLine.etdFromPort}}</span>
          </md-layout>
        </md-layout>

        <md-layout gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label for="toPort">To Port</label>
            <model-list-select
              @input="getLocationList($event,'Sea_Port','portListTPT')"
              @searchchange="getLocationList($event,'Sea_Port','portListTPT')"
              option-value="pickupId"
              option-text="pickupLocation"
              :list="portListTPT"
              placeholder="Select Port Name"
              v-model="BookingShippingLine.toPort"
            ></model-list-select>
            <span
              class="error"
              v-if="!BookingShippingLine.toPort"
            >{{errorBookingShippingLine.toPort}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>ETA(To Port)</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="etaToPort"
              name="etaToPort"
              v-model="BookingShippingLine.etaToPort"
            ></date-picker>
            <span
              class="error"
              v-if="!BookingShippingLine.etaToPort"
            >{{errorBookingShippingLine.etaToPort}}</span>
          </md-layout>
        </md-layout>
        <md-layout gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>Vessel Name and Voyage</label>
            <b-form-textarea :formatter="capitalizeAll"
              name="flightNo"
              id="flightNo"
              v-model="BookingShippingLine.vesselVoyage"
            ></b-form-textarea>

            <span
              class="error"
              v-if="!BookingShippingLine.vesselVoyage"
            >{{errorBookingShippingLine.vesselVoyage}}</span>
          </md-layout>
        </md-layout>
        <md-layout gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>IGM Filing Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="igmFilingDate"
              name="igmFilingDate"
              v-model="BookingShippingLine.igmFilingDate"
            ></date-picker>
            <span
              class="error"
              v-if="!BookingShippingLine.igmFilingDate"
            >{{errorBookingShippingLine.igmFilingDate}}</span>
          </md-layout>
          <md-layout md-flex="10"></md-layout>
          <md-layout
            md-flex="25"
            v-if="((mainPageModal.PODLocationId==mainPageModal.finalPlaceLocationId) && mainPageModal.containerInfo=='FclConsolidation')"
          >
            <label for="deStuffingLocationequal">Destuffing Location</label>
            <model-list-select
              option-value="deStuffingLocationequalText"
              option-text="deStuffingLocationequalVal"
              :list="deStuffingLocationequal"
              placeholder="Select Destuffing Location"
              v-model="BookingShippingLine.deStuffingLocationFcl"
            ></model-list-select>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout
            md-flex="25"
            v-if="((mainPageModal.PODLocationId==mainPageModal.finalPlaceLocationId) && mainPageModal.containerInfo=='FclConsolidation' && BookingShippingLine.deStuffingLocationFcl!='')"
          >
            <label for="deStuffingLocationequal">Destuffing Location</label>
            <model-list-select
              @input="getLocationList($event,'All','DestufListData')"
              @searchchange="getLocationList($event,'All','DestufListData')"
              option-value="pickupId"
              option-text="pickupLocation"
              :list="((this.BookingShippingLine.deStuffingLocationFcl=='Port')?this.DestufListData:this.DestufListData)"
              placeholder="Select Destuffing Location"
              v-model="BookingShippingLine.deStuffingLocationequal"
            ></model-list-select>
          </md-layout>
          <md-layout
            md-flex="30"
            v-if="((mainPageModal.PODLocationId!=mainPageModal.finalPlaceLocationId) && mainPageModal.containerInfo=='FclConsolidation')"
          >
            <label for="deStuffingLocationNequal">Destuffing Location1</label>
            <model-list-select
              @input="getLocationList($event,'All','DestufListData')"
              @searchchange="getLocationList($event,'All','DestufListData')"
              option-value="pickupId"
              option-text="pickupLocation"
              :list="DestufListData"
              placeholder="Select Destuffing Location"
              v-model="BookingShippingLine.deStuffingLocationNequal"
            ></model-list-select>
          </md-layout>
          <md-layout md-flex="30" v-if="mainPageModal.containerInfo=='LclConsolidation'">
            <label for="deStuffingLocationLcl">Destuffing Location</label>
            <model-list-select
              option-value="pickupId"
              option-text="pickupLocation"
              :list="DestufList"
              placeholder="Select Destuffing Location"
              v-model="BookingShippingLine.deStuffingLocationLcl"
            ></model-list-select>
          </md-layout>
        </md-layout>
        <md-layout gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>Gateway IGM No.</label>
            <b-form-input :formatter="capitalizeAll"
              name="gatewayIgmNo"
              id="gatewayIgmNo"
              v-model="BookingShippingLine.gatewayIgmNo"
            ></b-form-input>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>Gateway IGM Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="gatewayIgmDate"
              name="gatewayIgmDate"
              v-model="BookingShippingLine.gatewayIgmDate"
            ></date-picker>
          </md-layout>
        </md-layout>
        <md-layout gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>Local IGM No.</label>
            <b-form-input :formatter="capitalizeAll"
              name="gatewayIgmNo"
              id="gatewayIgmNo"
              v-model="BookingShippingLine.localIgmNo"
            ></b-form-input>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>Local IGM Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="gatewayIgmDate"
              name="gatewayIgmDate"
              v-model="BookingShippingLine.localIgmDate"
            ></date-picker>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
          <md-layout
            md-flex="20"
            v-if="mainPageModal.firstBlType=='MasterBL' && mainPageModal.firstBLRadio=='Original'"
          >
            <label>MBL Receiving Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="mblReceiveDate"
              name="mblReceiveDate"
              v-model="BookingShippingLine.mblReceiveDate"
            ></date-picker>
          </md-layout>
        </md-layout>
        <hr class="hr-border">
        <md-layout gutter v-for="(item,index) in multiHAWBL" :key="index" class="labelMargtop">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="30">
            <label for="clientId">HAWBL No.</label>

            <b-form-input :formatter="capitalizeAll" :value="item.secondBLNumber" disabled></b-form-input>
          </md-layout>

          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <label>SMTP No.</label>
            <b-form-input :formatter="capitalizeAll" name="smtpNo" id="smtpNo" v-model="smtpNo[index]"></b-form-input>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25" v-if="mainPageModal.containerInfo=='LclConsolidation'">
            <label for="cfsIcdLclHouseBL">CFS/ICD</label>
            <model-list-select
              @input="getLocationList($event,'All','DestufListData')"
              @searchchange="getLocationList($event,'All','DestufListData')"
              option-value="pickupId"
              option-text="pickupLocation"
              :list="DestufListData"
              placeholder="Select Location"
              v-model="cfsIcdLclHouseBL[index]"
            ></model-list-select>
            <!-- v-model="BookingShippingLine.cfsIcdLclHouseBL" -->
          </md-layout>
        </md-layout>
        <md-layout gutter v-if="BookingShippingLine.conSeaImportId!=''">
          <md-layout md-flex="70"></md-layout>
          <md-layout md-flex="30">
            <h4 class="showMoreData" @click="showDO">Click here for DO & Cargo(Documentation)</h4>
          </md-layout>
        </md-layout>
        <md-layout gutter v-if="BookingShippingLine.conSeaImportId!=''">
          <md-layout md-flex="70"></md-layout>
          <md-layout md-flex="30">
            <h4 class="showMoreData" @click="showNoc">Click here for NOC & Auth.(Documentation)</h4>
          </md-layout>
        </md-layout>

        <hr class="hr-s">
        <md-layout md-gutter>
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="30">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoader1"
              @click="addTransExec('fdsfdsf')"
            >Proceed To Tracking</md-button>
            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onCloseProceed"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editconSeaImportId") != "" &&
      this.$sessionsStorage.get("editconSeaImportId") != undefined
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/conSeaImport/ffConSeaImportExec"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  beforeDestroy() {},
  data() {
    return {
      selectDateFormat,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,
      bookingShipmentName: [
        {
          bookingShipmentVal: "yes",
          bookingShipmentText: "Yes"
        },
        {
          bookingShipmentVal: "no",
          bookingShipmentText: "No"
        }
      ],

      deStuffingLocationequal: [
        {
          deStuffingLocationequalVal: "Port",
          deStuffingLocationequalText: "Port"
        },
        {
          deStuffingLocationequalVal: "ICD/CFS",
          deStuffingLocationequalText: "ICD/CFS"
        }
      ],

      value12: "",
      getCLientData: ["gfdg"],
      multiHAWBL: [],
      smtpNo: [],
      cfsIcdLclHouseBL: [],
      BookingShippingLine: {
        conSeaImpExecId: "",
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId"),
        multiTransSeaExexId: "",
        fromPort: "",
        toPort: "",
        smtpNo: "",
        cfsIcdLclHouseBL: "",
        etdFromPort: "",
        etaToPort: "",
        vesselVoyage: "",
        bookingShipment: "",
        igmFilingDate: "",
        gatewayIgmNo: "",
        gatewayIgmDate: "",
        localIgmNo: "",
        localIgmDate: "",
        deStuffingLocationNequal: "",
        deStuffingLocationequal: "",
        cfsIcdLclHouseBL: "",
        deStuffingLocationLcl: "",
        deStuffingLocationFcl: "",
        mblReceiveDate: ""
      },
      portListFP: [],
      portListTP: [],
      portListFPT: [],
      portListTPT: [],
      execError: [
        "Select Transhipment",
        "Select IGM Filing Date",
        "Select From Port",
        "Select To Port",
        "Select ETD Date",
        "Select ETA Date",
        "Enter Flight No"
      ],
      errorBookingShippingLine: {
        bookingShipment: "",
        igmFilingDate: "",
        fromPort: "",
        toPort: "",
        etdFromPort: "",
        etaToPort: "",
        vesselVoyage: ""
      },

      portMasterList: [],
      DestufListData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      mainPageModal: {
        PODLocationId: "",
        finalPlaceLocationId: "",
        firstBlType: "",
        secondBlType: "",
        firstBLRadio: "",
        containerInfo: "",
        conSeaImportSeries: ""
      },

      moreAirportModel: {
        multiTransSeaExexId: "",
        ffairImpExecId: "",
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId"),
        fromPort: "",
        toPort: "",
        etaFromPort: "",
        etaToPort: "",
        vesselVoyage: ""
      },

      tentativeDetailArray: [],
      HAWBArray: [],
      agentMasterList: [],
      deleteId: "",
      validate: true,
      validateTrans: true,
      arrayErrorAirport: [
        "Select From Port",
        "Select To Port",

        "Select ETA Date",
        "Enter Flight No"
      ],
      errorAirport: {
        fromPort: "",
        toPort: "",

        etaToPort: "",
        vesselVoyage: ""
      },
      showAddAirport: false,

      editIndex: ""
    };
  },

  mounted() {},
  watch: {},
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
     CustomLoader,
    VueTrix,
    quillEditor
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },

    uploadBookingStatus() {
      return this.BookingShippingLine.uploadBooking != ""
        ? this.BookingShippingLine.uploadBooking.split(",")
        : [];
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },
    DestufList() {
      return this.DestufListData;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    }
  },
  methods: {
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    showAddAirportmet() {
      if (this.showAddAirport == false) {
        this.showAddAirport = true;
      } else {
        this.showAddAirport = false;
      }
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCloseProceed() {
      this.$router.push({
        path: "/SeaImport/conSeaImportTracking"
      });
    },
    onClose6(type) {},

    viewEdit(item, index) {
      this.showAddAirport = true;
      Object.keys(this.moreAirportModel).map(x => {
        this.moreAirportModel[x] = item[x];
      });
    },
    DeleteList(item, index) {
      this.deleteId = item.moreAirportId;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    previousAir() {
      this.$router.push({
        path: "/conSeaImport/ffConSeaImportFcl"
      });
    },

    validateAddAirport() {
      let validate_new = true;

      Object.keys(this.errorAirport).map((x, index) => {
        if (this.moreAirportModel[x] == "") {
          this.errorAirport[x] = this.arrayErrorAirport[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    addTransExec(id) {
      this.BookingShippingLine["smtpNo"] = "";
      this.BookingShippingLine["cfsIcdLclHouseBL"] = "";

      this.smtpNo.map(x => {
        this.BookingShippingLine["smtpNo"] += x + ",";
      });
      this.cfsIcdLclHouseBL.map(x => {
        this.BookingShippingLine["cfsIcdLclHouseBL"] += x + ",";
      });

      this.BookingShippingLine["ffairImportId"] = this.$sessionsStorage.get(
        "editffAirImportId"
      );

      if (this.validateTrans != false) {
        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine
        };

        if (id == "") {
          newData["onlyExecMain"] = "";
        } else {
          newData["onlyExecMain"] = "fdsfdsf";
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/conAddSeaImpExec.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              this.BookingShippingLine.conSeaImpExecId = data.conSeaImpExecId;

              Object.keys(this.moreAirportModel).map(x => {
                this.moreAirportModel[x] = "";
              });

              this.showAddAirport = false;
              if (id != "") {
                if (this.BookingShippingLine.conSeaImpExecId == "") {
                  this.alert.content = "Data Added Successfully";
                  this.$refs["addPop2"].open();
                } else {
                  this.alert.content = "Data Updated Successfully";
                  this.$refs["addPop2"].open();
                }
              }

              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    validateExec() {
      let validate_new = true;

      Object.keys(this.errorBookingShippingLine).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBookingShippingLine[x] = this.execError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    showDO() {
      this.$router.push({
        path: "/SeaImport/ConSeaImpDODoc"
      });
    },
    showNoc() {
      this.$router.push({
        path: "/SeaImport/ConNocdoc"
      });
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffBookingTentative").DataTable();
    //   });
    // },
    getData() {
      this.doLoading();
      if (this.tentativeDetailArray.length == 1) {
        this.tentativeDetailArray = [];
      }
      let new_data = {
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/fetchFFConSeaImportExec1.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            if (data.portLocationArray.length > 0) {
              this.portMasterList = data.portLocationArray.filter(x => {
                return x.locationType == "Sea_Port";
              });
            }
            if (data.ConsoSeaImportData.length > 0) {
              Object.keys(this.mainPageModal).map(x => {
                this.mainPageModal[x] = data.ConsoSeaImportData[0][x] || "";
              });
            }
            console.log(this.mainPageModal);
            if (data.ConSeaImportMultiHouseData.length > 0) {
              this.multiHAWBL = data.ConSeaImportMultiHouseData;
              this.mainPageModal.finalPlaceLocationId =
                data.ConSeaImportMultiHouseData[0].finalPlaceLocationId;
            }
            this.portListFP = data.portLocationArray;
            this.portListTP = data.portLocationArray;
            this.portListFPT = data.portLocationArray;
            this.portListTPT = data.portLocationArray;
            this.DestufListData = data.portLocationArrayFinal;

            // if (this.mainPageModal.containerInfo == "FclConsolidation") {
            //   if (data.portLocationArray.length > 0) {
            //     this.DestufListData = data.portLocationArray.filter(x => {
            //       return (
            //         x.locationType == "Client_Factory" ||
            //         x.locationType == "Icd" ||
            //         x.locationType == "Sea_Port"
            //       );
            //     });
            //   }
            // } else {
            //   if (data.portLocationArray.length > 0) {
            //     this.DestufListData = data.portLocationArray.filter(x => {
            //       return (
            //         x.locationType == "Client_Factory" ||
            //         x.locationType == "Icd"
            //       );
            //     });
            //   }
            // }
            if (data.conSeaImportExecData.length > 0) {
              Object.keys(this.BookingShippingLine).map(x => {
                if (x == "smtpNo") {
                  this.smtpNo = data.conSeaImportExecData[0][x].split(",");
                }
                if (x == "cfsIcdLclHouseBL") {
                  this.cfsIcdLclHouseBL = data.conSeaImportExecData[0][x].split(
                    ","
                  );
                }

                this.BookingShippingLine[x] =
                  data.conSeaImportExecData[0][x] || "";
              });
            } else {
              this.BookingShippingLine.fromPort =
                data.ConsoSeaImportData[0].PODLocationId;

              this.BookingShippingLine.toPort =
                data.ConSeaImportMultiHouseData[0].finalPlaceLocationId;

              this.BookingShippingLine.vesselVoyage =
                data.ConsoSeaImportData[0].vesselVoyage;
            }

            if (data.ConSeaExecTranshipment.length > 0) {
              this.tentativeDetailArray = data.ConSeaExecTranshipment;
            }
            this.doLoadingClose();
            //   this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ffConSeaImportExec.vue?510271b3